var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"conversation_container"},[_c('h1',{staticClass:"title"},[_vm._v("수리와 대화하기")]),_c('BubbleHonsuri'),_c('BubbleUser'),(this.$store.state.qna_count >= 16)?_c('BubbleResult'):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }